import React, { useState } from 'react';
import API from '../utils/api';

export default function WishlistButton({ childId, childName }) {
  const [show, setShow] = useState(false);
  const [wish, setWish] = useState('');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  const SUGGESTIONS = [
    'a story about dragons',
    'a space adventure',
    'a story with talking animals',
    'a mystery to solve',
    'a underwater adventure',
    'a story about friendship',
  ];

  const handleSave = async (e) => {
    e?.preventDefault();
    if (!wish.trim()) return;
    setSaving(true);
    setError('');
    try {
      await API.post('/wishlist', { childId, wish: wish.trim() });
      setSaved(true);
      setTimeout(() => { setSaved(false); setShow(false); setWish(''); }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Could not save wish.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <button
        className="btn rounded-pill d-flex align-items-center gap-2"
        style={{ background: 'var(--purple-section)', color: '#6f42c1', border: '1px solid var(--border-purple)', fontSize: '13px', padding: '8px 16px' }}
        onClick={() => setShow(true)}>
        <span>⭐</span>
        <span>I want a story about…</span>
      </button>

      {show && (
        <div className="modal show d-block" style={{ background: 'rgba(0,0,0,0.55)', zIndex: 1060 }}
          onClick={e => { if (e.target === e.currentTarget) setShow(false); }}>
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 380 }}>
            <div className="modal-content border-0 rounded-4">
              <div className="modal-body p-4">
                {saved ? (
                  <div className="text-center py-3">
                    <div style={{ fontSize: '48px', marginBottom: '8px' }}>⭐</div>
                    <h6 className="fw-bold" style={{ color: 'var(--text-main)' }}>Wish saved!</h6>
                    <p className="text-muted small">We'll tell {childName ? `${childName}'s parents` : 'your parents'}!</p>
                  </div>
                ) : (
                  <>
                    <div className="text-center mb-3">
                      <span style={{ fontSize: '32px' }}>⭐</span>
                      <h6 className="fw-bold mt-2 mb-1" style={{ color: 'var(--text-main)', fontFamily: "'Fredoka One',cursive" }}>
                        What story do you want next?
                      </h6>
                      <p className="text-muted small mb-0">Your parents will see your wish!</p>
                    </div>

                    {error && <div className="alert alert-danger py-1 small rounded-2 mb-2">{error}</div>}

                    <div className="d-flex flex-wrap gap-1 mb-3">
                      {SUGGESTIONS.map(s => (
                        <button key={s} type="button"
                          className="btn btn-sm rounded-pill"
                          style={{ background: wish === s ? '#6f42c1' : 'var(--item-bg)', color: wish === s ? 'white' : 'var(--text-muted2)', border: '1px solid var(--border-purple)', fontSize: '11px' }}
                          onClick={() => setWish(s)}>
                          {s}
                        </button>
                      ))}
                    </div>

                    <form onSubmit={handleSave}>
                      <input className="form-control mb-3" placeholder="Or type your own idea…" maxLength={150}
                        value={wish} onChange={e => setWish(e.target.value)} />
                      <div className="d-flex gap-2">
                        <button type="button" className="btn btn-outline-secondary rounded-pill flex-grow-1" onClick={() => setShow(false)}>Cancel</button>
                        <button type="submit" className="btn btn-dream rounded-pill flex-grow-1" disabled={saving || !wish.trim()}>
                          {saving ? '…' : '⭐ Save Wish'}
                        </button>
                      </div>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
